import { render, staticRenderFns } from "./CalendarWidgetContent.vue?vue&type=template&id=e0dc6a1c"
import script from "./CalendarWidgetContent.vue?vue&type=script&lang=js"
export * from "./CalendarWidgetContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../CitizenPortalUI_Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports